import {useSyncExternalStore} from "react";

const getWidth = () => (typeof window !== "undefined" ? window.innerWidth : 1920);

let currentWidth = getWidth();
let rafId = null;
const listeners = new Set();

const emit = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
        rafId = null;
        const next = getWidth();
        if (next === currentWidth) return;
        currentWidth = next;
        listeners.forEach((listener) => listener());
    });
};

const onMessage = (event) => {
    if (event?.data?.type === "SET_PADDING") emit();
};

const subscribe = (listener) => {
    if (listeners.size === 0) {
        window.addEventListener("resize", emit);
        window.addEventListener("message", onMessage);
    }

    listeners.add(listener);

    return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
            window.removeEventListener("resize", emit);
            window.removeEventListener("message", onMessage);
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        }
    };
};

const getSnapshot = () => currentWidth;
const getServerSnapshot = () => 1920;

const useGraphViewportWidth = () =>
    useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useGraphViewportWidth;
